import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UploadZipService {
  private organisationId = null;
  private fileUploadUrl = null;
  private fileContentUrl = null;
  subscriptionKey = null;

  constructor(private http: HttpClient) {
    this.fileUploadUrl = environment.fileUploadUrl;
    this.fileContentUrl = environment.fileContentUrl;
    this.subscriptionKey = environment.ocpApimSubscriptionKey;
    this.organisationId = sessionStorage.getItem('organizationid');
  }

  uploadZip(fileToUpload: File): Observable<Object> {
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    return this.http.post(this.fileUploadUrl, formData);
  }

  getZipContent() {
    return this.http.get(this.fileContentUrl + '/' + this.organisationId);
  }
}
